import * as ModalActions from '../actions/modal.actions';
import * as ModalState from '../states/modal.state';

export class State extends ModalState.State { }

const initialState: ModalState.State = ModalState.initialState;

/**
 * Reducer for the options bar component
 *
 * @export
 * @param {*} [state=initialState]
 * @param {ModalActions.Actions} action
 * @returns {ModalState.State}
 */
export function reducer(state = initialState, action: ModalActions.Actions): ModalState.State {

	switch (action.type) {
		case ModalActions.ActionTypes.PUT_SHOW_CLOSE:
			state = Object.assign({}, state, { showClose: action.payload });
			return state;
		case ModalActions.ActionTypes.RESET:
			state = Object.assign({}, state, initialState);
			return state;
		default:
			return state;
	}
}

export const getShowClose = (state: ModalState.State) => state.showClose;